// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import moment from "moment";
import config from "@config";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SectionComponent,
  GSGrid,
} from "@components";
import actionCreators from "@modules/reporting/actionCreator";
import {
  selectedLogReferralDetails,
  selectReferralCommonData,
} from "@modules/reporting/selectors/referral-tracker";
import type {
  CommonData,
  ReferralLogDetails,
} from "@modules/reporting/reducer/referral-tracker/types";

type OwnProps = $Exact<{
  data: number,
}>;

type PropsFromState = $Exact<{
  details: Array<ReferralLogDetails>,
  commonData: CommonData,
}>;

type PropsFromDispatch = $Exact<{
  toggleLogReferralDetailsModal: typeof actionCreators.ToggleLogReferralDetailsModal,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class WellbeingReferralLogModal extends Component<Props> {
  handleCancel = () => {
    this.props.toggleLogReferralDetailsModal();
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader className="d-flex justify-content-between" toggle={this.handleCancel}>
          {this.props.t("TREATMENT_OUTCOMES")} #{this.props.commonData.referralId}
        </ModalHeader>
        <ModalBody>
          <SectionComponent
            id="treatment-outcome-history"
            title={<h5>{this.props.t("TREATMENT_OUTCOME_HISTORY")}</h5>}
            wrapperClassName="flex-column my-4"
          >
            <GSGrid
              rows={this.props.details}
              columns={[
                {
                  name: this.props.t("DATE_TIME"),
                  key: "createdAt",
                  renderCell: ({ row }: { row: Object }) =>
                    moment(row.createdAt).format(config.dateTimeFormat),
                },
                {
                  name: this.props.t("USER"),
                  key: "createdBy",
                  renderCell: ({ row }: { row: Object }) =>
                    `${row.createdBy.firstName} ${row.createdBy.lastName}`,
                },
                {
                  name: this.props.t("SELECTED_ACTION"),
                  key: "action",
                  renderCell: ({ row }: { row: Object }) => `${row.outcome.outcome}`,
                },
                {
                  name: this.props.t("ADDITIONAL_COMMENTS"),
                  key: "comment",
                  cellClass: "p-0",
                  width: "50%",
                  renderCell: ({ row }: { row: Object }) => (
                    <textarea
                      disabled
                      rows="3"
                      maxLength="600"
                      className="no-resize background-color-white borders-solid-color-white fs-14 line-height-20"
                      defaultValue={row.comment}
                    />
                  ),
                },
              ]}
            />
          </SectionComponent>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleCancel}>
            {this.props.t("CLOSE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    details: selectedLogReferralDetails(state),
    commonData: selectReferralCommonData(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  toggleLogReferralDetailsModal: actionCreators.ToggleLogReferralDetailsModal,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(WellbeingReferralLogModal);
